import classNames from 'classnames';
import { LogoType } from '@Components/Base';
import { ReactComponent as LockIcon } from '@Icons/additional/lock.svg';

import styles from './document-tab-item.module.css';

interface MaterialDocumentItemProps {
  name: string;
  type: string;
  status: boolean;
  description: string;
}

const MaterialDocumentItem: React.FC<MaterialDocumentItemProps> = ({
  name,
  type,
  status,
  description,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.wrapper}>
          <div className={styles.documentIcon}>
            <LogoType fileExt={type} />
          </div>
          <div>
            <div className={classNames(styles.caption, styles.documentName)}>
              {name} <LockIcon />
            </div>
            <div className={styles.documentType}>{type}</div>
          </div>
        </div>
        <div className={styles.actions}>
          <div
            className={classNames(
              styles.state,
              status ? styles.inactive : styles.active
            )}
          >
            {status ? 'Inactive' : 'Active'}
          </div>
        </div>
      </div>
      <div className={styles.content}>{description}</div>
    </div>
  );
};

export default MaterialDocumentItem;
